import './styles.scss'

import { memo, useCallback, useState } from 'react'
import { Layout } from 'antd'
import clsx from 'clsx'
import Sticky from 'react-stickynode'

import { useCheckLocation } from '@/hooks'
import useDeviceDetect from '@/hooks/useDeviceDetect'
import { useSearchContext } from '@/contexts/search/useSearchContext'
import PermissionWrapper from '@/HOCs/permissionWrapper'
import { OFFSET_TOP, STICKY_Z_INDEX } from '@/libs/constants/header'
import { MODULE_SHOP_NAVIGATION_RIGHTS } from '@/libs/constants/modulerights'
import { renderHeaderSearchStickyTop } from '@/libs/utils/breakpointsValue'

import Search from '../../Search'
import HeaderLogoSection from './components'
import HeaderMenuMobile from './HeaderMenu/Mobile'

const { Header: HeaderLayout } = Layout

function Header() {
  const { isSearchFocused, setIsSearchFocused } = useSearchContext()

  const { isLargeScreen, isIpadLandscape } = useDeviceDetect()

  const [isShowDrawerMobile, setIsShowDrawerMobile] = useState(false)
  const { isInMyWorkspace } = useCheckLocation()

  const onCloseDrawerMobile = () => {
    setIsShowDrawerMobile(false)
  }

  const onShowDrawerMobile = useCallback(() => {
    setIsShowDrawerMobile(true)
    setIsSearchFocused(false)
  }, [setIsSearchFocused])

  const onFocusSearch = useCallback(() => {
    setIsSearchFocused(true)
  }, [setIsSearchFocused])

  const onBlurSearch = useCallback(() => {
    setIsSearchFocused(false)
  }, [setIsSearchFocused])

  const searchClass = clsx(
    'header__bottom__search__wrapper',
    isInMyWorkspace && 'header__bottom__search__wrapper-homepage',
    !isLargeScreen && 'header__bottom__search__wrapper--mobile',
  )

  return (
    <HeaderLayout className="header-wrapper">
      {/* Logo & Navigation */}
      <Sticky innerZ={STICKY_Z_INDEX.MENU} top={OFFSET_TOP.HEADER_MENU}>
        <HeaderLogoSection
          handleOnBlurSearch={onBlurSearch}
          onFocusSearch={onFocusSearch}
          onShowDrawerMobile={onShowDrawerMobile}
          onHideDrawerMobile={onCloseDrawerMobile}
        />
      </Sticky>
      {isShowDrawerMobile
        ? (
          <HeaderMenuMobile
            isShow={isShowDrawerMobile}
            onClose={onCloseDrawerMobile}
            onOpen={onShowDrawerMobile}
          />
        )
        : null}

      {isIpadLandscape
        ? (
          isSearchFocused && (
            <div
              className={searchClass}
              style={{
                position: 'absolute',
                zIndex: STICKY_Z_INDEX.SEARCH_IN_MOBILE,
              }}
            >
              <PermissionWrapper
                permission={MODULE_SHOP_NAVIGATION_RIGHTS.USE_SEARCH}
              >
                <Search />
              </PermissionWrapper>
            </div>
          )
        )
        : (
          <Sticky
            innerZ={STICKY_Z_INDEX.SEARCH}
            top={renderHeaderSearchStickyTop(isLargeScreen)}
          >
            {/* Search */}
            <PermissionWrapper
              permission={MODULE_SHOP_NAVIGATION_RIGHTS.USE_SEARCH}
            >
              <div className={searchClass}>
                {
                  /* Hide below content when scrolling in Main page in desktop
             <div className="header__bottom__search__yellow-banner" /> */
                }
                {isSearchFocused && (
                  <div className="header__bottom__search__background-layer--dim" />
                )}

                <Search />
              </div>
            </PermissionWrapper>
          </Sticky>
        )}
    </HeaderLayout>
  )
}

export default memo(Header)
